import { MemoryCategory } from './IMemory';

// Human-readable group headings for the observation-level rows in MemoryList and the category
// pill shown in the detail drawer. Kept in its own module so both can import it without the two
// components importing each other.
export const MEMORY_CATEGORY_LABELS: Record<MemoryCategory, string> = {
    'preference': 'Preferences',
    'health-observation': 'Health',
    'routine': 'Routines',
    'event-incident': 'Events',
    'logistics': 'Logistics',
    'living-situation': 'Living Situation',
    'caregiver-wellbeing': 'Caregiver Wellbeing',
    'relationship-dynamic': 'Relationships'
};
